import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AddIcon, Button } from "native-base";

export default function CreateTenantButton() {
  const navigate = useNavigate();

  const onCreateObject = useCallback(async () => {
    navigate(`/admin/tenants/create`);
  }, [navigate]);

  return (
    <Button
      onPress={onCreateObject}
      colorScheme="primary"
      startIcon={<AddIcon />}
      alignSelf="flex-end"
    >
      Mandant erstellen
    </Button>
  );
}
